import React from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import DownArrow from '../../svgs/downarrow.svg';
import { CourseFilterCheckbox } from './CourseFilterCheckbox';

interface CourseFilterCheckboxGroupProps {
    checkboxName: string;
    checkboxValue: string | number;
    checked: boolean;
    courseCount?: number;
    defaultExpanded: boolean;
    handleFilterChange: React.ChangeEventHandler<HTMLInputElement>;
    idPrefix?: string;
    indeterminate?: boolean;
    label: string;
}

const CourseFilterCheckboxGroup: React.FC<CourseFilterCheckboxGroupProps> = ({
    checkboxName,
    checkboxValue,
    checked,
    children,
    courseCount,
    defaultExpanded,
    handleFilterChange,
    idPrefix = '',
    indeterminate,
    label,
}) => {
    const [expanded, setExpanded] = React.useState(defaultExpanded);

    return (
        <>
            <Row className="mb-2">
                <Col className="pr-0 text-left">
                    <CourseFilterCheckbox
                        checkboxName={checkboxName}
                        checkboxValue={checkboxValue}
                        checked={checked}
                        courseCount={courseCount}
                        handleFilterChange={(e) => {
                            setExpanded(e.currentTarget.checked);
                            handleFilterChange(e);
                        }}
                        idPrefix={idPrefix + 'topic-'} // differentiate 'Math and Science' topic vs subTopic
                        indeterminate={indeterminate}
                        label={label}
                    />
                </Col>
                <Col className="text-right" xs="auto">
                    <Button
                        aria-expanded={expanded}
                        aria-label={`${label} Sub-Topics`}
                        className={`${
                            expanded ? '' : 'collapsed'
                        } border-0 d-flex font-weight-bold m-0 p-0 pt-1 stretched-link`.trim()}
                        onClick={() => setExpanded((e) => !e)}
                        variant="link"
                    >
                        <DownArrow className="collapse-flip size-1 text-muted" />
                    </Button>
                </Col>
            </Row>

            {expanded && children}
        </>
    );
};

export { CourseFilterCheckboxGroup };
